export const REJECT_CASE_STATUS = {
  NEW: 'NEW',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  ON_PARTNER_REVIEW: 'ON_PARTNER_REVIEW',
  PARTNER_APPROVED: 'PARTNER_APPROVED',
  PARTNER_DENIED: 'PARTNER_DENIED',
  WAITING_FOR_INVOICE: 'WAITING_FOR_INVOICE',
};
